import { ChangeDetectionStrategy, Component } from '@angular/core';



@Component({
	selector: 'plat-top-menu',
	templateUrl: './platTopMenu.component.html',
	styleUrls: ['./platTopMenu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatTopMenuComponent {}



// WEBPACK FOOTER //
// ./src/app/layout/components/platTopMenu/platTopMenu.component.ts